interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export const organizationSchema = {
  name: '凪光在线观看',
  url: 'https://subtitlesjp.github.io',
  description: '凪光全集高清免费在线播放平台，提供凪光系列动画、剧场版、OVA、原声音乐等内容的在线观看服务',
  sameAs: [
    'https://twitter.com/nagihikari',
    'https://weibo.com/nagihikari',
    'https://bilibili.com/nagihikari',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@nagihikari.com',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export const websiteSchema = {
  name: '凪光在线观看',
  url: 'https://subtitlesjp.github.io',
  description: '凪光全集高清免费在线播放平台',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://subtitlesjp.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export function buildBreadcrumbSchema(items: { name: string; url?: string }[]) {
  return {
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      ...(item.url ? { item: `https://subtitlesjp.github.io${item.url}` } : {}),
    })),
  };
}

export function buildArticleSchema(article: {
  title: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  url: string;
}) {
  return {
    headline: article.title,
    description: article.description,
    image: article.image,
    datePublished: article.datePublished,
    dateModified: article.dateModified,
    url: `https://subtitlesjp.github.io${article.url}`,
    author: {
      '@type': 'Organization',
      name: '凪光在线观看',
    },
    publisher: {
      '@type': 'Organization',
      name: '凪光在线观看',
    },
  };
}

export function buildFaqSchema(faqs: { question: string; answer: string }[]) {
  return {
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}